
















































import Vue from "vue";
// import moment from "moment";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import PancakeRouterV2ContractABI from "../assets/PancakeRouterV2ContractABI.json";
import BEP20ContractABI from "../assets/BEP20ContractABI.json";

export default Vue.extend({
  name: "SwapExactETHForTokens",

  data: () => ({
    web3: undefined as Web3 | undefined,
    connected: false as boolean,
    walletAddress: " " as string,
    balance: " " as string,
    toTokenAddress: "" as string,
    toTokenName: " " as string,
    fromTokenAddress: Web3.utils.toChecksumAddress("0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c") as string,
    fromTokenValue: "" as string,
    maybeAmount: 0 as number,
    maybeAmountInterval: 0 as number,
    amountOutMin: 1 as number,
    expiration: 120 as number,
    gasLimit: 1000000 as number,
    gasPrice: "5" as string,
    transactionCount: 1 as number,
    transactionResults: [] as Array<string>,
  }),
  methods: {
    async connect(): Promise<void> {
      const { ethereum } = window as any;
      if (!(ethereum /*&& ethereum.isMetaMask*/)) {
        alert("MetaMask がインストールされていません。");
      } else {
        const accounts = await ethereum.request({ method: "eth_requestAccounts" });
        this.web3 = new Web3(ethereum);
        const chainId = await this.web3.eth.getChainId();
        if (chainId != 56) {
          this.web3 = undefined;
          alert("BSC ネットワークで接続してください。");
        } else {
          ethereum.on("accountsChanged", () => {
            window.location.reload();
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          this.walletAddress = accounts[0];
          this.balance = Web3.utils.fromWei(await this.web3.eth.getBalance(this.walletAddress), "ether");
          this.connected = true;
        }
      }
    },
    async click(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      try {
        this.transactionResults.splice(0);

        const pancakeRouterV2ContractAbi = PancakeRouterV2ContractABI as any as AbiItem;
        const pancakeRouterV2ContractAddress = Web3.utils.toChecksumAddress("0x10ED43C718714eb63d5aA57B78B54704E256024E");
        const pancakeRouterV2Contract = new this.web3.eth.Contract(pancakeRouterV2ContractAbi, pancakeRouterV2ContractAddress);

        const data = pancakeRouterV2Contract.methods
          .swapExactETHForTokens(
            this.amountOutMin,
            [this.fromTokenAddress, Web3.utils.toChecksumAddress(this.toTokenAddress)],
            this.walletAddress,
            Math.floor(Date.now() / 1000) + this.expiration
          )
          .encodeABI();

        const nonce = await this.web3.eth.getTransactionCount(this.walletAddress);
        for (let i = 0; i < this.transactionCount; i++) {
          const transaction = {
            from: this.walletAddress,
            to: pancakeRouterV2ContractAddress,
            data: data,
            value: Web3.utils.toWei(this.fromTokenValue, "ether"),
            gas: this.gasLimit,
            gasPrice: Web3.utils.toWei(this.gasPrice, "gwei"),
            nonce: nonce + i,
          };

          this.web3.eth
            .sendTransaction(transaction)
            .on("receipt", (receipt) => {
              const transactionStatus = receipt.status ? "Success" : "Failed";
              this.transactionResults.push(`transactionHash: ${receipt.transactionHash}, result: ${transactionStatus}`);
            })
            .on("error", (error) => {
              this.transactionResults.push(error.message);
            });
        }
      } catch (error) {
        this.transactionResults.push(error);
      }
    },
  },
  watch: {
    toTokenAddress(newValue, oldValue) {
      if (newValue != null && newValue != oldValue) {
        try {
          const tokenAddress = Web3.utils.toChecksumAddress(newValue);
          if (this.web3 != null) {
            const genericContractAbi = BEP20ContractABI as any as AbiItem;
            const tokenContract = new this.web3.eth.Contract(genericContractAbi, tokenAddress);

            Promise.all([tokenContract.methods.symbol().call()])
              .then((results) => {
                this.toTokenName = results[0];
              })
              .catch((error) => {
                this.toTokenName = " ";
              });
          }
        } catch (error) {
          this.toTokenName = " ";
        }
      } else {
        this.toTokenName = " ";
      }
    },
  },
});
